import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Server } from 'selenium-webdriver/safari';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'receipts-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({


        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class ServicesComponent implements OnInit, OnChanges  {
  
  ngOnChanges(changes: SimpleChanges) {

    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = change;
        this.selectedServices = [];

      }
    }

  }
  @Input() services: services[];
  @Output() servicesObject = new EventEmitter();
  @Input() enableChange;
  @Input() currenceis;
  @Input() changing: boolean;
  productTypeSelected: boolean;
  isOpen: boolean = true;
  goodsValue: string = '';
  selectedServices: any[] = [];
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  validationMessage: string = '';
  @Output() isEnableSelectCommodity = new EventEmitter();
  @ViewChild('isFocus') isFocus: ElementRef;
  constructor(private translate: TranslateService) {
    this.productTypeSelected = false;
  }
 
  selectServices(service) {
    if (service.Code == "CODR")
      service.RequiresAmountToBeSpecified = true;

    var index = this.selectedServices.findIndex(function (item, i) {
      return item.Code == service.Code;
        });

        if (index > -1)
            this.selectedServices.splice(index, 1)
        else
            this.selectedServices.push(service);
        //this.isFocus.nativeElement.focus();
  }

  updateServiceValue(value, serviceName) {
    this.selectedServices.some((obj) => {
      if (obj.Code == serviceName) {
        obj.value = value;
        return true;
      }
    })
  }
  updateCurrancy(value, serviceName) {
    this.selectedServices.some((obj) => {
      if (obj.Code == serviceName) {
        obj.currancy = value;
        return true;
      }
    })
  }

  isSeletedService(service) {
    var index = this.selectedServices.findIndex(function (item, i) {
      return item.Code == service.Code;
    });
    if (index > -1)
      return true
    else
      return false
  }

  getServices() {
    var servicesWithValue = this.selectedServices.filter(x => x.RequiresAmountToBeSpecified == true);
    var valid = true
    servicesWithValue.forEach((obj, index) => {
      if (obj.value == null || obj.value == '') {
        valid = false
      }
    });
    if (valid) {
      this.servicesObject.emit(this.selectedServices);
      this.isEnableSelectCommodity.emit(true);
      this.isOpen = !this.isOpen;
    }
    else {
      this.validationMessage = '<i class="unvalid armx-icon armx-cancel"></i> ' + `${this.translate.instant('pages.createReceiptPage.errorMsgs.minShipmentItem')}`;
    }
  }

  change() {
    this.isEnableSelectCommodity.emit(false);
    this.branchCurrencyCode = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
    this.isOpen = !this.isOpen;
    }

  ngOnInit() {
  }
}
